import React, { Component, Fragment } from 'react';
import { Filter, Main } from 'Containers/';
import { connect } from 'react-redux';
import _ from 'lodash';

import { withRouter } from 'react-router';
import { MBENotificationLettersForm } from './components/MBENotificationLettersForm';
import moment from 'moment';
import { MBENotificationLettersFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { MBE_NOTIFICATION_LETTERS_FORM_NAME } from 'Common/FormEnum';
import {
  fetchInitialData,
  processMBE,
  clearBadEmails,
  processCEPTransfer,
} from './state/letters/actions';
import { LoadingPage, YesNoDialog } from 'Components/';
import { toastType, createToast } from 'Common/ToastHelper';
import {
  MBENotificationLetterTypes,
  MBENotificationLetterHistoryTypes,
} from 'Common/Constants/Enumeration/MBENotificationLetterTypes';

class MBENotificationContainer extends Component {
  state = {
    showEmailConfirm: false,
    emailConfirmed: false,
    emailSubmit: null,
  };

  componentDidMount() {
    this.props.fetchInitialData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { error } = this.props;

    if (error) {
      createToast(toastType.error, 'Error', error.toString(), true);
    }
  }

  getMainProps = () => {
    return {
      toolbox: {
        formName: MBE_NOTIFICATION_LETTERS_FORM_NAME,
        saveButtonProps: {
          content: 'Process',
          loading: this.props.loading,
        },
        shown: true,
      },
    };
  };

  handleSubmit = formValues => {
    const { [Fields.LetterType]: letterType, ...model } = formValues;

    if (_.get(formValues, 'PrintType', 0) === 1 && !this.state.emailConfirmed) {
      this.setState({ showEmailConfirm: true });
      return;
    }

    this.setState({ emailConfirmed: false });

    if (letterType === MBENotificationLetterTypes.MBENotification) {
      const data = {
        ...model,
        SelectedCalendars: this.props.selectedCalendars,
      };

      this.props.processMBE(data);
    } else {
      this.props.processCEPTransfer(model);
    }
  };

  emailSubmit = funct => {
    this.setState({ emailSubmit: funct });
  };

  getBadEmailQuestion = letterType => {
    const badCount = this.getBadEmailCount(letterType).toString();

    const letterDescription =
      letterType === MBENotificationLetterHistoryTypes.MBENotification
        ? 'MBE'
        : 'CEP Transfer';

    const plural = badCount > 1 ? 's' : '';
    const wasWere = badCount > 1 ? 'were' : 'was';
    const badEmailAddressDesc =
      badCount > 1 ? 'bad email addresses' : 'a bad email address';
    const thisThese = badCount > 1 ? 'these' : 'this';
    var title = `[${badCount}] ${letterDescription} Notification email${plural} ${wasWere} returned due to ${badEmailAddressDesc}.`;
    var title2 = `Do you want to print ${thisThese} letter${plural}?`;
    return (
      <span>
        {title}
        <br />
        {title2}
      </span>
    );
  };

  declineToPrintFailedEmails = letterType => {
    const letters = this.props.badEmailLetterHistoryIds.filter(x => {
      return x.LetterType === letterType;
    });

    const data = {
      letterHistoryIds: letters.map(x => {
        return x.Id;
      }),
    };
    this.props.clearBadEmails(data);
  };

  acceptToPrintFailedEmails = (letterHistoryType, letterType) => {
    const badLetterHistoryLetters = this.props.badEmailLetterHistoryIds.filter(
      x => x.LetterType === letterHistoryType
    );

    const data = {
      BadEmailLetterHistoryIds: badLetterHistoryLetters.map(x => x.Id),
      IsPrintBadEmails: true,
      [Fields.LetterType]: letterType,
    };
    this.handleSubmit(data);
  };

  acceptToPrintEmails = () => {
    this.setState(
      {
        showEmailConfirm: false,
        emailConfirmed: true,
      },
      this.state.emailSubmit
    );
  };

  declineToPrintEmails = () => {
    this.setState({ showEmailConfirm: false, emailConfirmed: false });
  };

  getBadEmailCount = letterType => {
    return this.props.badEmailLetterHistoryIds.filter(
      x => x.LetterType === letterType
    ).length;
  };

  showCEPBadEmailDialog = () => {
    return (
      this.getBadEmailCount(
        MBENotificationLetterHistoryTypes.CEPTransferNotification
      ) > 0 &&
      this.getBadEmailCount(
        MBENotificationLetterHistoryTypes.MBENotification
      ) === 0
    );
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage message={'Loading'} /> : undefined}

        <Filter title={'MBE Notification'} />
        <Main {...this.getMainProps()}>
          <MBENotificationLettersForm
            onSubmit={this.handleSubmit}
            onEmailSubmit={this.emailSubmit}
            initialValues={{
              [Fields.PrintType]: 0,
              [Fields.SortByType]: 0,
              [Fields.AddressFromType]: 0,
              [Fields.ShowSiteName]: false,
              [Fields.LetterDate]: defaultDateFormat(moment()),
              [Fields.LetterType]: MBENotificationLetterTypes.MBENotification,
            }}
          />
        </Main>
        <YesNoDialog
          showDialog={
            this.getBadEmailCount(
              MBENotificationLetterHistoryTypes.MBENotification
            ) > 0
          }
          title={'MBE Notification has failed email(s).'}
          question={this.getBadEmailQuestion(
            MBENotificationLetterHistoryTypes.MBENotification
          )}
          yesCallback={() => {
            this.acceptToPrintFailedEmails(
              MBENotificationLetterHistoryTypes.MBENotification,
              MBENotificationLetterTypes.MBENotification
            );
          }}
          noCallback={() => {
            this.declineToPrintFailedEmails(
              MBENotificationLetterHistoryTypes.MBENotification
            );
          }}
        />
        <YesNoDialog
          showDialog={this.showCEPBadEmailDialog()}
          title={'CEP Transfer Notification has failed email(s).'}
          question={this.getBadEmailQuestion(
            MBENotificationLetterHistoryTypes.CEPTransferNotification
          )}
          yesCallback={() => {
            this.acceptToPrintFailedEmails(
              MBENotificationLetterHistoryTypes.CEPTransferNotification,
              MBENotificationLetterTypes.CEPTransferNotification
            );
          }}
          noCallback={() => {
            this.declineToPrintFailedEmails(
              MBENotificationLetterHistoryTypes.CEPTransferNotification
            );
          }}
        />
        <YesNoDialog
          showDialog={this.state.showEmailConfirm}
          title={'Email MBE Notification Letters?'}
          question={
            <span>
              Emails will immediately be sent to parents/guardians; there is no
              preview before they send.
              <br />
              Do you wish to continue?
            </span>
          }
          yesCallback={this.acceptToPrintEmails}
          noCallback={this.declineToPrintEmails}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { report } = state.MBENotificationLettersState;

  return {
    selectedCalendars: report.selectedCalendars,
    badEmailLetterHistoryIds: report.badEmailLetterHistoryIds,
    loading: report.loading,
  };
};

const mapDispatchToProps = {
  fetchInitialData,
  processMBE,
  clearBadEmails,
  processCEPTransfer,
};

export const MBENotification = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MBENotificationContainer)
);



// WEBPACK FOOTER //
// ./src/pages/mbenotification/MBENotification.js